// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    login as loginApi,
    logout as logoutApi,
    signup as signupApi,
    forgotPassword as forgotPasswordApi,
    forgotPasswordConfirm,
} from '../../helpers/';

import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { authApiResponseSuccess, authApiResponseError } from './actions';
import { AuthActionTypes } from './constants';

const api = new APICore();

/**
 * Login the user
 * @param {*} payload - email and password
 */
function* login({ payload: { email, password } }) {
    try {
        const response = yield call(loginApi, { email, password });
        const user = response.data.response;
        if (user !== null) {
            // NOTE - You can change this according to response format from your api
            api.setLoggedInUser(user);
            setAuthorization(user['token']);
            yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
        } else {
            yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, true));
            api.setLoggedInUser(null);
            setAuthorization(null);
        }
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

/**
 * Logout the user
 */
function* logout() {
    try {
        yield call(logoutApi);
        api.setLoggedInUser(null);
        setAuthorization(null);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER, {}));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER, error));
    }
}

function* signup({ payload: { fullname, email, password } }) {
    try {
        const response = yield call(signupApi, { fullname, email, password });
        const user = response.data;
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.SIGNUP_USER, user));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.SIGNUP_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

function* forgotPassword({ payload: { email } }) {
    try {
        const response = yield call(forgotPasswordApi, { email });
        const data = response.data.response;
        
        if (data !== null) {
            yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD, data));
        } else {
            yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, "Failed to send reset email"));
        }
    } catch (error) {
        const errorMessage = error.response?.data?.error || error.message || "Something went wrong";
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, errorMessage));
    }
}

function* forgotPasswordChange({ payload }) {
    try {
        const response = yield call(forgotPasswordConfirm, payload);
        const resultData = response.data.response;
        
        if (resultData !== null) {
            yield put(authApiResponseSuccess(AuthActionTypes.RESET_PASSWORD, resultData));
        } else {
            yield put(authApiResponseError(AuthActionTypes.RESET_PASSWORD, "Failed to reset password"));
        }
    } catch (error) {
        const errorMessage = error.response?.data?.error || error.message || "Something went wrong";
        yield put(authApiResponseError(AuthActionTypes.RESET_PASSWORD, errorMessage));
    }
}

export function* watchLoginUser() {
    yield takeEvery(AuthActionTypes.LOGIN_USER, login);
}

export function* watchLogout() {
    yield takeEvery(AuthActionTypes.LOGOUT_USER, logout);
}

export function* watchSignup() {
    yield takeEvery(AuthActionTypes.SIGNUP_USER, signup);
}

export function* watchForgotPassword() {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD, forgotPassword);
}

// export function* watchForgotPasswordChange() {
//     yield takeEvery(AuthActionTypes.FORGOT_PASSWORD_CHANGE, forgotPasswordChange);
// }

export function* watchResetPassword() {
    yield takeEvery(AuthActionTypes.RESET_PASSWORD, forgotPasswordChange);
}

function* authSaga() {
    yield all([
        fork(watchLoginUser),
        fork(watchLogout),
        fork(watchSignup),
        fork(watchForgotPassword),
        // fork(watchForgotPasswordChange),
        fork(watchResetPassword),
    ]);
}

export default authSaga;
